export enum PartnerActions {
  Reset = "reset",
}
